import { SB } from '@play-co/replicant';

const tournamentPlayerSchema = SB.object({
  // Score in the tournament
  score: SB.int(),

  // For leaderboard sorting, in case of equal score, the earliest should be higher
  scoreUpdatedAt: SB.int(),
});

const tournamentEventSchema = SB.object({
  // Flag to indicate if the player has claimed the prize
  claimed: SB.boolean(),

  // Upon claiming the prize, the player's final rank will be recorded here
  finalRank: SB.int().optional(),

  // The main player participating in the event
  player: tournamentPlayerSchema,

  // Opponents participating in the event (using real player data)
  opponentList: SB.array(SB.string()),

  // Method of match making used for creating the opponent list, for analytics purpose
  matchMakingCriteria: SB.string().optional(),

  // Multiplier used for calculating the score.
  multiplier: SB.int(),

  // Tournament theme type
  type: SB.string(),
});

export type Match2TournamentEvent = SB.ExtractType<
  typeof tournamentEventSchema
>;

export const tournamentSchema = {
  // List of tournament events player has participated in. Each event is identified by a unique id that is also their start time
  events: SB.map(tournamentEventSchema),
  // Timestamp for the last time user has started a tournament, used for searching players
  lastStartedAt: SB.int().optional(),
  // Timestamp for the end of the current tournament the user has started, for searching players in the correct tournament type
  currentEndAt: SB.int().optional(),
  // Type of the current tournament the user is
  currentType: SB.string().optional(),
  // Timestamp for the last time user has finished a tournament in top 3
  lastWinAt: SB.int().optional(),
  // Position of the player in the last tournament
  lastRank: SB.int().optional(),
  // Matchmaking algorithm used for the last tournament user has participated in
  lastMatchMakingCriteria: SB.string().optional(),
};
